import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import AddTermCondition from "./AddTermAndCondition";
import WebService from "../../utility/WebService";

const TermCondition = () => {
  const [showTermCondition, setShowTermCondition] = useState(false);
  const [termCondition, setTermCondition] = useState<any>(null);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getTermCondition();
  }, []);

  const getTermCondition = () => {
    WebService.getAPI({
      action: `term-condition/detail`,
    })
      .then((res: any) => {
        setTermCondition(res.data.data);
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
      })
      .catch((err: any) => {
        console.error(err);
      });
  };

  return (
    <>
      <AddTermCondition
        show={showTermCondition}
        handleClose={() => {
          setShowTermCondition(false);
          getTermCondition();
        }}
        data={termCondition}
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Term And Condition</div>
            {pagePermission.canEdit && (
              <CustomButton
                isLoading={false}
                label={termCondition == null ? "Add" : "Edit"}
                onClick={() => {
                  setShowTermCondition(true);
                }}
                style={{ width: 100 }}
              />
            )}
          </div>
          {termCondition == null ? (
            <div className="text-center mt-3">
              No Term and Condition available
            </div>
          ) : (
            <span className="mt-3 d-block" style={{ padding: "20px 30px" }}>
              <img
                src={termCondition?.image}
                alt="Privacy Policy"
                width={250}
              />
               <div className="ql-snow">
              <div
                className="mt-2 px-0 ql-editor"
                dangerouslySetInnerHTML={{ __html: termCondition.description }}
              />
              </div>
              <hr />
            </span>
          )}
        </Card>
      </div>
    </>
  );
};

export default TermCondition;
